"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClassname = void 0;
const ulid_1 = require("ulid");
function createClassname() {
    return 'userstyle-' + ulid_1.ulid().toLowerCase();
}
exports.createClassname = createClassname;
//# sourceMappingURL=create-classname.js.map